import Home from "./Pages/Home/Home";
import { Routes, Route, HashRouter } from "react-router-dom";
import Createaccount from "./Pages/Createaccount/Createaccount";
import AccountSuccess from "./Pages/AccountSuccessful/AccountSuccess";
import Header from "./Components/Header/Header";
import TokenPage from "./Pages/TokenPage/TokenPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import MainContextProvider from "./context/Main/MainContextProvider";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <MainContextProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:rmDetails" element={<Home />} />
            <Route path="/createaccount" element={<Createaccount />} />
            <Route path="/token/:userCode/:uniqueID" element={<TokenPage />} />
            <Route
              path="/success/:AccountNUBAN/:CustomerNumber"
              element={<AccountSuccess />}
            />
          </Routes>
        </MainContextProvider>
      </HashRouter>
    </div>
  );
}

export default App;
